up.compiler('[destroy-voucher-cashing]', (element) => {
  let button = element.querySelector('.btn')
  let input = element.querySelector('input[name*="_destroy"]')

  function markForDestruction() {
    if (!confirm("Gutschein enfernen?")) return

    input.setAttribute('value', true)
    let form = element.closest('form')
    up.validate(form, {target: '.booking--total-price'})
  }

  if (button) {
    button.addEventListener('click', markForDestruction)
  }
})
